import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';

export class PrimaryDiagnosis{
	description: string;
	primaryDiagnosisCode: string;
	trfFlag: string;
}

@Component({
	selector: 'app-case-copy-image-dailog',
	templateUrl: './case-copy-image-dailog.component.html',
	styleUrls: ['./case-copy-image-dailog.component.scss']
})
export class CaseCopyImageDailogComponent implements OnInit {

	public copyImageRows: Array<object> = [];
	public isSelectedAll: boolean = false;
	public caseRows: Array<object> = [];
	public isCopyBtnDisable: boolean = true;
	public errorList: Array<string> = [];
	public anatomicSiteDesc: Array<object> = [];
	public anatomicSiteNoValidation: boolean = false;
	public selectedAnatomicCode: string = '';
	public matchedDiagnosis: PrimaryDiagnosis = new PrimaryDiagnosis();
	public primaryDiagnosisList: Array<PrimaryDiagnosis> = [];

	constructor(private ptImageMappingService: PtImageMappingService,
		public dialogRef: MatDialogRef<CaseCopyImageDailogComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData: any) {
	}

	ngOnInit(): void {
		// IF SEARCH BY ANATOMIC SITE - TO POPULATE TABLE AND RIGHT SECTION.
		if (this.dailogData.anatomicSiteCode) {
			this.ptImageMappingService.getAnatomicSiteList().subscribe((result: Array<object>) => {
				this.anatomicSiteDesc = result;
			});
			this.getAnatomicSiteCopyImage(this.dailogData.anatomicSiteCode, this.dailogData.diagnosisCode);
		}

		// IF SEARCH BY CASE # - TO POPULATE THE TABLE AND RIGHT SECTION
		if (this.dailogData.caseNumberID) {
			for (let i = 1; i <= 10; i++) {
				this.caseRows.push({
					index: i,
					value: '',
					error: ''
				});
			}

			this.getCaseNumberCopyImage(this.dailogData.caseNumberID);
		}
	}

	// TO CHANGE SPECIMEN AND TO SET THE BUTTON DISABLE OR ENABLE.
	onChangeSpecimen = (event, image) => {
		if (event.target.checked) {
			if (image == 'all') {
				this.copyImageRows.forEach((item: any) => item.isSelected = true)
			} else {
				image.isSelected = true;
			}
		} else {
			if (image == 'all') {
				this.copyImageRows.forEach((item: any) => item.isSelected = false);
			} else {
				image.isSelected = false;
				this.isSelectedAll = false;
			}
		}

		this.isCopyButtonDisabled();
	}

	// ON MAILING KEY UP EVENT - TO SET BUTTON DISABLE OR ENALBE.
	onKeyUpMailing = (event) => {
		this.isCopyButtonDisabled();
		event.target.value = (event.target.value.length <= 7) ? event.target.value : event.target.value.substring(0, 7);
	}

	// TO GET THE ANATOMIC SITE BASED ON THE ANATOMIC SITE AND POPULATE TABLE.
	getAnatomicSiteCopyImage = (anatomicSiteCodeID, primaryID) => {
		this.ptImageMappingService.getAnatomicSiteCopyImages(anatomicSiteCodeID, primaryID).subscribe((result: Array<Object>) => {
			this.copyImageRows = result;
		});
	}

	// TO GET THE TABLE DATA BASED ON THE CASE NUMBER AND POPULATE TABLE.
	getCaseNumberCopyImage = (caseNumberID) => {
		this.ptImageMappingService.getCaseNumberCopyImage(caseNumberID).subscribe((result: Array<Object>) => {
			this.copyImageRows = result;
		});
	}

	// ON CHANGE ANATOMIC SITE DROPDOWN.
	onChangeAnatomicSite = event => {
		this.primaryDiagnosisList = [];
		if (event.target.value !== '') {
			this.populatePrimaryDiagnosis(event.target.value);
		}
		this.isCopyButtonDisabled();
	}

	// POPULATE DIAGNOSIS DROPDOWN
	populatePrimaryDiagnosis = siteCode => {
		this.ptImageMappingService.populatePrimaryDiagnosis(siteCode).subscribe((result: Array<PrimaryDiagnosis>) => {
			this.primaryDiagnosisList = result;
			const diagnosis = this.primaryDiagnosisList.find( (item: PrimaryDiagnosis) => item.primaryDiagnosisCode === this.dailogData.diagnosisCode);
			this.matchedDiagnosis = (diagnosis != undefined) ? diagnosis : new PrimaryDiagnosis();
		});
	}

	// TO SET BUTTON DISABLE OR ENABLE.
	isCopyButtonDisabled = () => {
		const copyImageRows = this.copyImageRows.find((item: any) => item.isSelected == true);
		if (this.dailogData.anatomicSiteCode) {
			this.isCopyBtnDisable = (this.selectedAnatomicCode !== '' && copyImageRows !== undefined) ? false : true;
		}

		if (this.dailogData.caseNumberID) {
			const caseRows = this.caseRows.find((item: any) => item.value !== '');
			this.isCopyBtnDisable = (caseRows !== undefined && copyImageRows !== undefined) ? false : true;
		}
	}

	// TO PREPARE THE DATA FOR COPY IMAGE AND TO CALL THE SERVICE AND SAVE THE DATA IN DATABASE.
	splitCopyImageConfigParam = (selectedAnatomic, editedMailingRows) => {
		return {
			caseNumber: (this.dailogData.caseNumberID) ? this.dailogData.caseNumberID : '',
			toAnatomicSiteCd: this.selectedAnatomicCode,
			toAnatomicSiteDesc: (selectedAnatomic !== null) ? selectedAnatomic.description : '',
			fromAnatomicSiteCd: (this.dailogData.anatomicSiteCode) ? this.dailogData.anatomicSiteCode : '',
			diagnosisCd: this.dailogData.diagnosisCode,
			selectedImages: this.copyImageRows.filter((item: any) => item.isSelected == true),
			toCases: editedMailingRows,
			diagnosis: this.dailogData.diagnosis
		};
	}

	splitCopyErrorMsg = result => {
		if (result && (result.copySuccessful == null || result.copySuccessful == false) && result.warningMsgs.length > 0) {
			this.errorList = result.warningMsgs;
		}
		if (result && (result.copySuccessful == null || result.copySuccessful == false) && result.errorMsgs.length > 0) {
			this.errorList = result.errorMsgs;
		}

		if(result && result.caseErrors){
			this.caseRows.forEach( (item:any) => {
				if(item.value != ''){
					item.error = result.caseErrors[item.value];
				}
			});
		}
	}

	splitCopyImageValidServiceCall = (config, selectedAnatomic, editedMailingRows) => {
		this.ptImageMappingService.caseValidateCopyImage(config).subscribe(result => {
			if (result.copySuccessful) {
				this.dialogRef.close({
					success: true,
					noOfImage: (config.selectedImages.length <= 1) ? '1 Image' : `${config.selectedImages.length} Images`,
					code: (this.dailogData.anatomicSiteCode) ? `${selectedAnatomic.description} ${this.selectedAnatomicCode}` : editedMailingRows.join(', ')
				});
			}
			this.splitCopyErrorMsg(result);
		});
	}

	clickCopyImageButton = () => {
		const editedMailingRows = [];
		if (this.dailogData.caseNumberID) {
			this.caseRows.forEach((item: any) => {
				item.error = '';
				if (item.value !== '')
					editedMailingRows.push(item.value)
			});
		}

		let selectedAnatomic = null;
		if (this.selectedAnatomicCode !== '') {
			selectedAnatomic = this.anatomicSiteDesc.find((item: any) => item.code === this.selectedAnatomicCode);
		}

		const configParam = this.splitCopyImageConfigParam(selectedAnatomic, editedMailingRows);
		this.splitCopyImageValidServiceCall(configParam, selectedAnatomic, editedMailingRows);
	}

}